import { cn } from "@omni/utils/styles";
import { useSelector } from "react-redux";

import { LoggedInLinks } from "@/components/Navigation/Sidebar/components/accountLinks/components/loggedInLinks";
import { LoggedOutLinks } from "@/components/Navigation/Sidebar/components/accountLinks/components/loggedOutLinks";
import { useSidebarContext } from "@/components/Navigation/Sidebar/context/sidebar.context";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import * as SoftLoginService from "@/services/softLogin.service";
import { rewriteAccountLinksForSoftLogin } from "@/utils/account";

export const AccountLinks = () => {
    const { accountLinks, profileLink } = useSidebarContext();

    const customer = useSelector(CustomerSelectors.getCustomer);

    const loggedIn = !!customer && !customer.guest;
    const softLoggedIn = loggedIn || SoftLoginService.isSoftLoggedIn();

    const menuItems = rewriteAccountLinksForSoftLogin(
        loggedIn,
        accountLinks,
        profileLink
    );

    return (
        <div className={cn("tw:border-y tw:border-grey-light")}>
            {softLoggedIn && <LoggedInLinks pageLinks={menuItems ?? []} />}
            {!softLoggedIn && <LoggedOutLinks profileLink={profileLink} />}
        </div>
    );
};
